module.exports = __webpack_public_path__ + "img/IMG_9674-4.d96b83b9.png";